import React from 'react';

import ReactDOM from 'react-dom';

import top from './top.png';

import './index.css';

import './Header.css';

import ChangePswd from './ChangePswd';

import Wydzialy from './Wydzialy';

import Lista from './Lista';

import Opinie from './Opinie';

import Lista_zestawienia from './Lista_zestawienia';

import Logowanie from './Log';

import axios from 'axios';

import swal from 'sweetalert';

import Rok from './Rok';

import Info from './Info';

import apiurl from './apiurl';

import Header from './Header';

import WRok from './WRok';

import Rejestr from './Rejestr';

import Zaangazowanie from './Zaangazowanie';

import SQR from './SQR';
import Opinie2 from './Opinie2';
import Konfiguracja from './konfiguracja/Konfiguracja';





export default class NavBar extends React.Component {

    constructor(props) {

    super(props);    

      this.state = {

      token: props.token,

      username: props.username,

      id: props.id,

      nazwastrony: props.nazwastrony,

      kodoper: props.kodoper,

      Header1: true,

      Header2: false,

      cleantimer: 0,

      rok: props.rok,

      active: 'Lista', 
      showSQR: true,
      showUmowy: false,
      czyOpinie: true,
      admin: false,
      };

    }

    

  componentDidMount() {    

    ReactDOM.render(<Header token={this.state.token}/>, document.getElementById("nav"));


    // const konfig =  JSON.parse(sessionStorage.getItem("konfig")) ? JSON.parse(sessionStorage.getItem("konfig")) : [];
    // console.log(konfig)
    // this.setState({ 
    //   showSQR: konfig.sqr,
    //   czyOpinie: konfig.opinie,
    // })
  }



  active(name) {

    if(name === 'Lista' || name === 'Wydzialy' || name === 'Gen_zestawienie' || name === 'Opinie' || name === 'Opinie2' || name === 'Rejestr' || name === 'Zaangazowanie' || name === 'SQR'){

    this.setState({active : name})

    }



  }



  componentWillReceiveProps(nextProps) {

    this.setState({ token: nextProps.token, username: nextProps.username, id: nextProps.id, kodoper: nextProps.kodoper, rok: nextProps.rok, nazwastrony: nextProps.nazwastrony})  

    ReactDOM.render(<Header token={this.state.token}/>, document.getElementById("nav"));

    this.active(nextProps);

    // if(nextProps) {

    //   const konfig =  JSON.parse(sessionStorage.getItem("konfig")) ? JSON.parse(sessionStorage.getItem("konfig")) : [];
    //   console.log(konfig)
    //   this.setState({ 
    //     showSQR: konfig.sqr,
    //     czyOpinie: konfig.opinie,
    //   })
    // }

    if(nextProps.rok !== this.state.rok) {
      axios.get(apiurl+"api/Konfig", {params : {rok : nextProps.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }})
          .then(response => {
            sessionStorage.setItem("konfig", JSON.stringify(response.data));
          })
          .catch(error => console.log('Error - config'));
    }

  }



  counterclick() {

    this.setState(({ cleantimer }) => ({ cleantimer: cleantimer + 1 }));

  }



  przejdz = (name) => {

    const Componenty = {
      "ChangePswd": ChangePswd,
      "Wydzialy": Wydzialy,
      "Rok": Rok,
      "Lista": Lista,
      "Gen_zestawienie": Lista_zestawienia,
      "Opinie": Opinie,
      "Opinie2": Opinie2,
      "Info": Info,
      "Rejestr": Rejestr,
      "Zaangazowanie": Zaangazowanie,
      "SQR": SQR,
      "Konfiguracja": Konfiguracja,
    }

    let TagName = Componenty[name];  

    if(this.state.token === 'brak'){

    swal("Musisz sie zalogować !", {

      closeOnClickOutside: false,

      buttons: {

        do: {

          text: "OK",

          value: "do",

        },

      },

    })

    .then((value) => {

      switch (value) {

        case "do":

          ReactDOM.render(<Logowanie />, document.getElementById("root"));

          break;

      }

    });

    }

    if(this.state.rok === undefined ) {

      this.setState({ active : "Lista" })

      ReactDOM.render(<WRok  token = {this.state.token} />, document.getElementById("root"));

    }

    else{

    ReactDOM.render(<TagName  token = {this.state.token} username = {this.state.username} id = {this.state.id} rok={this.state.rok} kodoper={this.state.kodoper} nazwastrony={this.state.nazwastrony}/>, document.getElementById("root"));

    this.active(name);

    }

  }



  logout = () => {

    axios.post(apiurl+"api/Auth/logout", null , 

        {headers : { 'Authorization' : "Bearer " + this.state.token } })

        .then(() => {

          ReactDOM.render(<Logowanie />, document.getElementById("root"));

        })

    .catch(() => swal("Nie wylogowano!"));

  }





  render() {

  const { rok, username, active, showUmowy, } = this.state

  const Lista = active === "Lista" ? ("active") : ("");

  // const Wydzialy = active === "Wydzialy" ? ("active") : ("");

  const Gen = active === "Gen_zestawienie" ? ("active") : ("");

  // const Opinie = active === "Opinie" ? ("active") : ("");

  const Opinie2 = active === "Opinie2" ? ("active") : ("");

  const Rok = active === "Rok" ? ("active") : ("");

  const ChangePswd = active === "ChangePswd" ? ("active") : ("");

  // const Rejestr = active === "Rejestr" ? ("active") : ("");

  // const Zaangazowanie = active === "Zaangazowanie" ? ("active") : ("");

  // const SQR = active === "SQR" ? ("active") : ("");

  const Konfig = active === "Konfiguracja" ? ("active") : ("");

  const konfiguracja =  JSON.parse(sessionStorage.getItem("konfig")) ? JSON.parse(sessionStorage.getItem("konfig")) : [];


  return (

  <React.Fragment>

  <aside id="main-sidebar" className="sidenav">

  <section className="sidebar" >

  <ul className="sidebar-menu">

    <li className="treeview" >           

    { rok ? (<a className={Lista} href="#"  onClick={() => this.przejdz('Lista')}><i className="center fas fa-coins"></i> <span className="napis"> Dokumenty</span></a>) : (<a className={Lista} href="#" ><i className="center fas fa-coins"></i> <span className="napis"> Dokumenty</span></a>)}

    </li>

    {/* <li className="treeview" >           

    { rok ? (<a className={Wydzialy} href="#"  onClick={() => this.przejdz('Wydzialy')}><i className="center fas fa-id-card"></i> <span className="napis"> Wydziały</span></a>) : (<a className={Wydzialy} href="#"><i className="center fas fa-id-card"></i> <span className="napis"> Wydziały</span></a>)}

    </li> */}

    {/* <li className="treeview" >           

    { rok ? (<a className={Opinie} href="#"  onClick={() => this.przejdz('Opinie')}><i class="fas fa-comment"></i> <span className="napis"> Opinie</span></a>) : (<a className={Opinie} href="#"><i class="fas fa-comment"></i> <span className="napis"> Opinie</span></a>)}

    </li> */}

    {konfiguracja.opinie && <li className="treeview" >           

    { rok ? (<a className={Opinie2} href="#"  onClick={() => this.przejdz('Opinie2')}><i class="fas fa-comment"></i> <span className="napis"> Opinie</span></a>) : (<a className={Opinie2} href="#"><i class="fas fa-comment"></i> <span className="napis"> Opinie</span></a>)}

    </li>}

    {/* <li className="treeview" >   

    { rok ? (<a className={Zaangazowanie} href="#" onClick={() => this.przejdz('Zaangazowanie')}><i class="far fa-file-alt" aria-hidden="true"></i> <span className="napis"> Zaangażowanie</span></a>) : (<a className={Rejestr} href="#" ><i class="far fa-file-alt" aria-hidden="true"></i> <span className="napis"> Zaangażowanie</span></a>)}

    </li> */}

    {/* {showUmowy ? (<li className="treeview" >   

    { rok ? (<a className={Rejestr} href="#" onClick={() => this.przejdz('Rejestr')}><i class="far fa-file-alt" aria-hidden="true"></i> <span className="napis"> Umowy</span></a>) : (<a className={Rejestr} href="#" ><i class="far fa-file-alt" aria-hidden="true"></i> <span className="napis"> Umowy</span></a>)}

    </li>) : null} */}

    <li className="treeview" >           

    { rok ? (<a className={Gen} href="#"  onClick={() => this.przejdz('Gen_zestawienie')}><i className="center fas fa-print"></i> <span className="napis"> Zestawienia</span></a>) : (<a className={Gen} href="#" ><i className="center fas fa-print"></i> <span className="napis"> Zestawienia</span></a>)}

    </li>

    {/* {showSQR ? (<li className="treeview" >           

    { rok ? (<a className={SQR} href="#"  onClick={() => this.przejdz('SQR')}><i className="center fas fa-print"></i> <span className="napis"> SQR</span></a>) : (<a className={SQR} href="#" ><i className="center fas fa-print"></i> <span className="napis"> SQR</span></a>)}

    </li>) : null } */}

    <li className="treeview" >           

    { rok ? ( <a className={Rok} href="#"  onClick={() => this.przejdz('Rok')}><i className="center far fa-calendar"></i> <span className="napis">Zmień rok ({rok})</span></a>) : (<a className={Rok} href="#" onClick={() => this.przejdz('Rok')} ><i className="center far fa-calendar"></i> <span className="napis">Zmień rok</span></a>)}

    </li>

    <li className="treeview" >           

      <a className={ChangePswd} href="#" onClick={() => this.przejdz('ChangePswd')}><i className="center fas fa-key"></i> <span className="napis"> Zmień hasło</span></a>

    </li>

    {konfiguracja.adm && <li className="treeview" >           
      <a className={Konfig} href="#" onClick={() => this.przejdz('Konfiguracja')}><i className="center fas fa-key"></i> <span className="napis"> Konfiguracja</span></a>
    </li>}



  </ul>

  </section>

  </aside >

  

  </React.Fragment>

  );

  }

  }

